angular
    .module("skillBuilderSaaS")
    .directive("sbSpinner", function () {
    return {
        template: "<div class='view-loader fade in'><span class='spinner'></span></div>",
        link: function (_scope, element) {
            element.parent().addClass("has-spinner");
        }
    };
});
